<template>
  <v-container flat>
    <v-layout justify-center row>
      <v-flex xs12 v-if="pictureVerifyFlag === true">
        <v-card class="pa-3">
          <v-form ref="form">
            <v-layout>
              <v-flex xs12>
                <v-text-field
                  label="手机"
                  prepend-icon="$vuetify.icons.phone"
                  v-model="form.phone"
                  :disabled="disabledFlag || form.type === 'chengjiao'"
                  type="number"
                  hint="若您的手机号码变更，请输入新号！"
                  :rules="$rules.phone11()"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout column>
            <v-layout>
              <v-flex xs12>
                <v-text-field
                  class="pb-1"
                  single-line
                  label="验证码"
                  type="number"
                  placeholder="请输入验证码"
                  prepend-icon="$vuetify.icons.code"
                  v-model="verifyObj.verifyCode"
                  :disabled="disabledFlag === true"
                  :error-messages="
                    disabledFlag === true ? '' : verifyObj.errorMessage
                  "
                ></v-text-field>
              </v-flex>

              <div>
                <v-btn
                  flat
                  color="primary"
                  @click="
                    getTmpToken();
                    verifyObj.getFlag = true;
                  "
                  :disabled="disabledFlag === true"
                  v-if="verifyObj.expire <= 0"
                >
                  <span v-if="!verifyObj.getFlag">获取短信验证码</span>
                  <span v-else>重新获取</span>
                </v-btn>
                <span v-else style="font-size: 16px"
                  >{{ verifyObj.expire }}s</span
                >
              </div>
            </v-layout>
            <v-layout justify-center>
              <v-btn
                class="primary"
                @click="submit"
                :disabled="verifyObj.verifyCode.length === 0"
                >提交</v-btn
              >
            </v-layout>
          </v-layout>
        </v-card>
      </v-flex>

      <v-flex v-else>
        <v-layout>
          <v-flex xs12>
            <v-text-field
              class="pb-1"
              single-line
              label="验证码"
              type="number"
              placeholder="请输入图形验证码"
              prepend-icon="$vuetify.icons.code"
              v-model="verifyObj.verifyCode"
              :disabled="disabledFlag === true"
              :error-messages="
                disabledFlag === true ? '' : verifyObj.errorMessage
              "
            ></v-text-field>
          </v-flex>

          <div>
            <v-btn
              flat
              color="primary"
              @click="
                getTmpToken('picture');
                verifyObj.getFlag = true;
              "
              :disabled="disabledFlag === true"
              v-if="verifyObj.expire <= 0"
            >
              <span v-if="!verifyObj.getFlag">获取验证码</span>
              <span v-else>重新获取</span>
            </v-btn>
            <span v-else style="font-size: 16px">{{ verifyObj.expire }}s</span>
          </div>
        </v-layout>
        <div v-if="verifyObj.pic !== ''">
          <img :src="`data:image/png;base64,${verifyObj.pic}`" />
        </div>
        <v-layout justify-center>
          <v-btn
            class="primary"
            @click="checkCode"
            :disabled="verifyObj.verifyCode.length === 0"
            >数据验证</v-btn
          >
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  name: "parse",
  data() {
    return {
      form: {
        phone: "",
        jsCode: "",
        key: "",
        type: "",
      },
      verifyObj: {
        show: false,
        getFlag: false,
        expire: 0,
        key: "",
        verifyCode: "",
        verifyKey: "",
        errorMsg: "",
        checkStatus: false,
        pic: "",
        premsg: "",
      },
      pictureVerifyFlag: false,
      disabledFlag: false,
    };
  },
  created() {
    this.init();
    this.getTmpToken("picture");
  },
  methods: {
    init() {
      this.form.jsCode = this.$route.query.jsCode;
      this.form.phone = this.$route.query.phone;
      this.form.key = this.$route.query.key;
      this.form.type = this.$route.query.type;
    },
    async getTmpToken(type = "msg") {
      this.verifyObjReset();
      let res = await this.$store.dispatch(
        "letterReservation/selfSign_getTmpToken"
      );
      if (res.data.status === 1) {
        this.verifyObj.expire = 60;
        this.verifyObj.key = res.data.data.key;
        this.sendVertifyMessage(type);
      } else {
        this.$L.alert("error", { message: res.data.msg });
      }
    },
    async sendVertifyMessage(type) {
      if (type === "msg") {
        let res = await this.$store.dispatch(
          "letterReservation/selfSign_getVerifyMsg",
          {
            key: this.verifyObj.key,
            phone: this.form.phone,
            hash: this.verifyObj.premsg,
          }
        );
        if (res.data.status === 1) {
          this.verifyObj.verifyKey = res.data.data.verifyKey;
        } else {
          this.$L.alert("error", { message: res.data.msg });
        }
      } else {
        let res = await this.$store.dispatch(
          "letterReservation/selfSign_getVerifyMsgPic",
          { key: this.verifyObj.key }
        );
        if (res.data.status === 1) {
          this.verifyObj.verifyKey = res.data.data.verifyKey;
          this.verifyObj.pic = res.data.data.verify;
          this.verifyObj.premsg = res.data.data.premsg;
        } else {
          this.$L.alert("error", { message: res.data.msg });
        }
      }
    },
    async checkCode() {
      this.disabledFlag = true;
      let config = {
        verifyKey: this.verifyObj.verifyKey,
        realMsg: this.verifyObj.verifyCode,
        premsg: this.verifyObj.premsg,
      };
      let res = await this.$store.dispatch(
        "letterReservation/selfSign_checkVerify",
        config
      );
      if (res.data.status === 1) {
        if (!this.pictureVerifyFlag) {
          this.pictureVerifyFlag = true;
          this.disabledFlag = false;
          // this.getTmpToken();
        }
        this.verifyObjReset();
        return true;
      } else {
        this.$L.alert("error", { message: res.data.msg });
        this.disabledFlag = false;
        this.verifyObj.expire = -1;
        this.verifyObj.errorMsg = res.data.msg + ",请重新获取";
        return false;
      }
    },
    verifyObjReset() {
      this.verifyObj.show = false;
      this.verifyObj.getFlag = false;
      this.verifyObj.verifyCode = "";
      this.verifyObj.errorMsg = "";
      this.verifyObj.expire = -1;
      this.verifyObj.pic = "";
    },
    async submit() {
      if (!this.pictureVerifyFlag) {
        await this.checkCode();
        return;
      }
      let checkRes = await this.checkCode();
      if (checkRes) {
        this.verifyObj.expire = 0;
        let param = {
          jscode: this.form.jsCode,
          key: this.form.key,
          verifyKey: this.verifyObj.verifyKey,
          phone: this.form.phone,
        };
        /* console.log(param) */
        let res = await this.$store.dispatch("wx/parseData", param);
        if (res.data.status === 1) {
          this.$L.alert("success", { message: "注册成功" });
          let aim = this.$route.query.aim;
          if (
            aim.indexOf("selfSign") !== -1 ||
            aim.indexOf("personSelfSign") !== -1
          ) {
            let redirectUrl =
              "https://smaco2.uestc.edu.cn/wx/autoLogin?aim=" + aim;
            window.location.href =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
              redirectUrl +
              "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
          } else {
            let redirectUrl =
              "https://smaco2.uestc.edu.cn/wx/autoLogin?aim=" + aim;
            window.location.href =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
              redirectUrl +
              "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
          }
        } else {
          this.$L.alert("error", { message: res.data.msg });
          setTimeout(function () {
            let aim = this.$route.query.aim;
            let redirectUrl =
              "https://smaco2.uestc.edu.cn/wx/validate?aim=" + aim;
            window.location.href =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfd33224488b5cf00&redirect_uri=" +
              redirectUrl +
              "&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
          }, 5 * 1000);
        }
      }
    },
  },
  watch: {
    "verifyObj.expire"(val, oldVal) {
      if (val > 0) {
        if (val > oldVal) {
          setTimeout(() => {
            this.verifyObj.expire = val - 1;
          }, 1000);
        } else {
          setTimeout(() => {
            this.verifyObj.expire -= 1;
          }, 1000);
        }
      } else if (val === 0) {
        this.verifyObj.errorMessage = "验证码已过期，请重新获取";
      } else {
      }
    },
    "verifyObj.verifyCode"() {
      // console.log('change')
      this.verifyObj.errorMessage = "";
    },
  },
};
</script>
